export default __webpack_public_path__ + "static/media/3.63e1556c.jpg";